import { SetLanguageForTheSessionContentBody } from '../types/generated/languageSet_post.content';
import { SetLanguageForTheSessionResponseBody } from '../types/generated/languageSet_post.response';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestSetLanguageUser = (
  body: SetLanguageForTheSessionContentBody,
  token: string | null,
  forceHeader?: string
): Promise<SetLanguageForTheSessionResponseBody> =>
  fetcher<SetLanguageForTheSessionResponseBody>(
    apiEndpoints.routes.setLanguageUser,
    'POST',
    token,
    forceHeader,
    undefined,
    body
  );
